<template>
  <div class="pro-forma-visual" aria-hidden="true">
    <div class="pro-forma-visual__title">
      <span class="pro-forma-visual__name">Jan Drissen</span>
      <ShowcasePill tone="grey">PARTICULIER</ShowcasePill>
      <span class="pro-forma-visual__amount">€ 4.143</span>
    </div>
    <span class="pro-forma-visual__subtitle">2x solar screen, via configurator</span>

    <span class="pro-forma-visual__label">OFFERTETRAJECT</span>
    <template v-for="(step, index) in steps" :key="step.title">
      <span v-if="index > 0" class="pro-forma-visual__line"></span>
      <div
        class="pro-forma-visual__step"
        :class="{ 'pro-forma-visual__step--active': !step.done }"
      >
        <span
          class="pro-forma-visual__number"
          :class="{ 'pro-forma-visual__number--done': step.done }"
        >
          {{ step.done ? '✓' : index + 1 }}
        </span>
        <div class="pro-forma-visual__step-text">
          <strong>{{ step.title }}</strong>
          <small>{{ step.description }}</small>
        </div>
        <ShowcasePill :tone="step.pill.tone">{{ step.pill.label }}</ShowcasePill>
      </div>
    </template>

    <div class="pro-forma-visual__actions">
      <span class="pro-forma-visual__button">Bekijk pro forma</span>
      <span class="pro-forma-visual__button pro-forma-visual__button--primary">
        Maak definitieve offerte
      </span>
    </div>
  </div>
</template>

<script>
  import ShowcasePill from './ShowcasePill.vue';

  export default {
    name: 'ProFormaVisual',
    components: { ShowcasePill },
    setup() {
      const steps = [
        {
          title: 'Pro forma',
          description: 'Automatisch gemaakt uit de configuratie',
          pill: { label: 'PRO FORMA', tone: 'yellow' },
          done: true,
        },
        {
          title: 'Inmeting',
          description: 'Cas meet op wo 15 okt',
          pill: { label: 'INMETING', tone: 'blue' },
          done: true,
        },
        {
          title: 'Definitieve offerte',
          description: 'Maten uit de inmeting, prijs herberekend',
          pill: { label: 'DEFINITIEF', tone: 'purple' },
          done: false,
        },
      ];

      return { steps };
    },
  };
</script>

<style scoped lang="scss">
  .pro-forma-visual {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 480px;
    max-width: 100%;
    padding: 18px;
    border: 1px solid var(--showcase-stroke);
    border-radius: 10px;
    background-color: var(--white);
    color: var(--showcase-ink);
    box-shadow:
      0 1px 2px rgba(0, 9, 33, 0.06),
      0 8px 24px rgba(0, 9, 33, 0.07);

    &__title {
      display: flex;
      align-items: center;
      gap: 8px;
      width: 100%;
    }

    &__name {
      font-size: 15px;
      font-weight: 500;
      line-height: 22px;
    }

    &__amount {
      margin-left: auto;
      font-size: 13px;
      font-weight: 500;
      line-height: 20px;
    }

    &__subtitle {
      color: var(--showcase-text);
      font-size: 12px;
      line-height: 20px;
    }

    &__label {
      padding: 16px 0 4px;
      color: var(--showcase-muted);
      font-size: 10px;
      font-weight: 500;
      line-height: 15px;
      letter-spacing: 0.4px;
    }

    &__step {
      display: flex;
      align-items: center;
      gap: 12px;
      width: 100%;
      padding: 10px 12px;
      border: 1px solid var(--showcase-stroke);
      border-radius: 8px;
      background-color: var(--white);
      &--active {
        border-color: var(--showcase-primary);
        background-color: var(--showcase-primary-tint);
      }
    }

    &__line {
      width: 1.5px;
      height: 14px;
      margin-left: 22px;
      background-color: var(--showcase-stroke-button);
    }

    &__number {
      display: flex;
      flex-shrink: 0;
      align-items: center;
      justify-content: center;
      width: 22px;
      height: 22px;
      border-radius: 12px;
      background-color: var(--showcase-blue-bg);
      color: var(--showcase-primary);
      font-size: 11px;
      font-weight: 500;
      line-height: 14px;
      &--done {
        background-color: var(--showcase-green-bg);
        color: #009a5f;
      }
    }

    &__step-text {
      display: flex;
      flex: 1;
      flex-direction: column;
      min-width: 0;
      white-space: nowrap;
      strong {
        font-size: 13px;
        font-weight: 500;
        line-height: 20px;
      }
      small {
        color: var(--showcase-text);
        font-size: 12px;
        line-height: 18px;
      }
    }

    &__actions {
      display: flex;
      justify-content: flex-end;
      gap: 8px;
      width: 100%;
      margin-top: 14px;
    }

    &__button {
      padding: 3px 10px;
      border: 1px solid var(--showcase-stroke-button);
      border-radius: 6px;
      background-color: var(--white);
      font-size: 13px;
      line-height: 20px;
      white-space: nowrap;
      &--primary {
        border-color: var(--showcase-primary);
        background-color: var(--showcase-primary);
        color: var(--white);
      }
    }
  }
</style>
